export interface ParsedAgentSummary {
  fields: { key: string; label: string; value: string }[];
  conversationLog: { role: string; content: string }[] | null;
  attachments: string[] | null;
}

export function parseAgentSummary(summary: string): ParsedAgentSummary {
  const fields: ParsedAgentSummary["fields"] = [];
  let conversationLog: ParsedAgentSummary["conversationLog"] = null;
  let attachments: ParsedAgentSummary["attachments"] = null;

  if (/<(?:caseId|productName|productCode|transferReason|conversationSummary|conversationLog|attachments)\b/i.test(summary)) {
    const document = new DOMParser().parseFromString(summary, "text/html");
    const fieldKeys: Record<string, string> = {
      caseid: "Case_ID",
      productname: "Product_Name",
      productcode: "Product_Code",
      transferreason: "Transfer_Reason",
      conversationsummary: "Conversation_Summary",
    };

    for (const element of Array.from(document.body.children)) {
      const tag = element.localName;
      if (tag === "conversationlog") {
        conversationLog = Array.from(element.children)
          .filter((turn) => turn.localName === "turn")
          .map((turn) => {
            const speaker = turn.getAttribute("speaker")?.trim() || "Unknown";
            return {
              role: speaker.charAt(0).toUpperCase() + speaker.slice(1),
              content: turn.textContent?.trim() || "",
            };
          });
      } else if (tag === "attachments") {
        attachments = Array.from(element.children)
          .filter((attachment) => attachment.localName === "attachment")
          .map((attachment) => attachment.textContent?.trim() || "")
          .filter(Boolean);
      } else if (fieldKeys[tag]) {
        const key = fieldKeys[tag];
        fields.push({
          key,
          label: key === "Case_ID" ? "Case ID" : key.replace(/_/g, " "),
          value: element.textContent?.trim() || "",
        });
      }
    }

    return { fields, conversationLog, attachments };
  }

  for (const match of summary.matchAll(/\[(\w+)\]:?\s*([\s\S]*?)\s*\[\/\1\]/g)) {
    const [, key, rawValue] = match;
    const value = rawValue.trim();

    if (key === "Conversation_Log") {
      conversationLog = Array.from(
        value.matchAll(/\[(\w+)\]([\s\S]*?)\[\/\1\]/g),
        (turn) => ({ role: turn[1], content: turn[2].trim() })
      );
    } else if (key === "Attachments") {
      attachments = value
        .split(/\r?\n/)
        .map((line) => line.replace(/^[-*]\s*/, "").trim())
        .filter(Boolean);
    } else {
      fields.push({
        key,
        label: key === "Case_ID" ? "Case ID" : key.replace(/_/g, " "),
        value,
      });
    }
  }

  return { fields, conversationLog, attachments };
}